import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import TaskDo from "./TaskDo";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class MyTasks extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'solution/task/my',
            data: null,
            loading: true,
            systemModuleId: 24,
            moduleAccessStatus: 1
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.addKeyDown();
                this.refreshData();
            });
    }
    showTaskDo(record) {
        this.removeKeyDown();
        this.showComponents({
            component: <TaskDo Caller={this} Record={record} /> });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    {this.isEmpty(this.state.data.records) ?
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>در حال حاضر این وظیفه ای برای شما محول نشده است</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row g-gs">
                            {this.state.data.records.map((record, index) =>
                                <div className="col-sm-6 col-lg-6 col-xxl-3">
                                    <div className="card card-bordered h-100">
                                        <div className="card-inner">
                                            <div className="project">
                                                <div className="project-head">
                                                    <a onClick={e => this.showTaskDo(record)} className="hand project-title">
                                                        <div className="project-info">
                                                            <h6 className="title">{record.description}</h6>
                                                            <span className="sub-text">پروژه: {record.solutionName}</span>
                                                            <span className="sub-text">گردش کاری: {record.workFlowName}</span>
                                                            <span className="sub-text">گام: {record.workFlowStepName}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="project-meta">
                                                    <a onClick={e => this.showTaskDo(record)} className="hand">
                                                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> انجام</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}